import type { ReactNode } from 'react';

type PageHeaderProps = { title: string; description: ReactNode };

export function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <header data-enter="" className="flex flex-col gap-1.5">
      <h1 className="font-semibold text-title">{title}</h1>
      <p className="text-muted">{description}</p>
    </header>
  );
}
